import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import _ from "lodash";
import Button from "react-bootstrap-button-loader";
import { fetchclientInvoiceinfo } from "Actions";
import { screenHeightLeftFromTop } from "Constants";
import MenuIcon from "MenuIcon";
import renderHTML from "react-render-html";
import { converDateIntoLocalwithmonth, MAIN_URL } from "Constants";
import LocaleStrings from "Languages";
import PaymentinvoiceModal from "../../components/dashboard/components/accountsettings/components/billing-details/billinghistorytable/paymentmodal";
var Loader = require("react-loaders").Loader; // import "AwesomeLoaderCss";

class Billingpayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      btnLoading: false,
      invoiceid: {},
      payModal: false,
      loading: true,
      invoicedata: [],
    };
  }
  openpayModal = () => {
    this.setState({
      payModal: true,
    });
  };
  closepayModal = () => {
    this.setState({ payModal: false });
  };

  componentDidMount() {
    var url_string = window.location.href;

    var invoiceid = url_string.split("?")[1];
    // this.setState({invoiceid:invoiceid});
    this.props.fetchclientInvoiceinfo(
      this.props.session,
      invoiceid,
      (response) => {
        if (response && response.data) {
          this.setState({ invoicedata: response.data });
          this.setState({ loading: false });
        }
      }
    );
  }

  renderLogoMenuIcon() {
    var menuIcon = { iconName: "", bsClass: "Logo", description: "" };
    return <MenuIcon key="StaticIcon" menuItem={menuIcon} />;
  }

  renderLoader = () => {
    return (
      <Loader type="line-scale-pulse-out-rapid" active className="loader-div" />
    );
  };

  renderList = (e) => {
    let { clientinvoiceforpayment } = this.props;
    let item = _.map(
      clientinvoiceforpayment.data[0].clientinvoiceitems_by_invoiceidfk,
      (data, index) => {
        var descriptionData = "";
        if (data.descriptiontext) {
          descriptionData = data.descriptiontext.replaceAll("\n", "<br/>");
        }
        return (
          <>
            <tr key={index} id={index}>
              <td className="td4">
                <div className="" style={{ fontWeight: 700 }}>
                  {data.itemname}
                </div>
                <div className="">{renderHTML(descriptionData)}</div>
              </td>
              <td className="td3">
                {" "}
                <div className="ml-10"> {data.quantity} </div>
              </td>
              <td className="td3">
                {" "}
                <div className="ml-10"> {data.price} </div>
              </td>
              <td className="td3">
                {" "}
                <div className="ml-10"> ${data.total}</div>
              </td>
            </tr>
            {data.discountpercentage !== 0 &&
            data.discountpercentage !== null ? (
              <tr key={index} id={index}>
                <td className="td4">
                  <div className="" style={{ fontWeight: 700 }}>
                    {data.discounttext !== null ? data.discounttext : ""}
                  </div>
                </td>
                <td className="td3">
                  {" "}
                  <div className="ml-10"> </div>
                </td>
                <td className="td3">
                  {" "}
                  <div className="ml-10">
                    {
                      LocaleStrings.accountsetting_billing_details_table_viewbillmodaldiscountedprice
                    }{" "}
                    ({data.discountpercentage}%)
                  </div>
                </td>
                <td className="td3">
                  {" "}
                  <div className="ml-10">
                    -${parseFloat(data.discountamount)}
                  </div>
                </td>
              </tr>
            ) : (
              ""
            )}
          </>
        );
      }
    );
    return item;
  };

  fetchURLs(message) {
    var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
    return message.match(urlRegex);
  }

  render() {
    let { clientinvoiceforpayment, deviceSize } = this.props;
    let { invoicedata } = this.state;
    let paid = false;

    if (invoicedata && invoicedata.length > 0) {
      if (invoicedata.status == "paid") {
        paid = true;
      }
    }

    let tabledate = "";
    let validupto = "";
    let location = "";
    let plantype = "";
    let usercredit = "";

    var contentData = "";
    if (
      clientinvoiceforpayment.data &&
      clientinvoiceforpayment.data.length > 0 &&
      clientinvoiceforpayment.data[0].terms
    ) {
      contentData = clientinvoiceforpayment.data[0].terms.replaceAll(
        "\n",
        "<br/>"
      );

      tabledate = converDateIntoLocalwithmonth(
        clientinvoiceforpayment.data[0].createdon
      ).format("D MMM YYYY");
      if (
        clientinvoiceforpayment.data[0].validitytill != "" &&
        clientinvoiceforpayment.data[0].validitytill != null
      )
        validupto = converDateIntoLocalwithmonth(
          clientinvoiceforpayment.data[0].validitytill
        ).format("D MMM YYYY");
    }

    if (
      clientinvoiceforpayment.data &&
      clientinvoiceforpayment.data.length > 0 &&
      clientinvoiceforpayment.data[0].clients_by_clientid.plantype
    ) {
      plantype = clientinvoiceforpayment.data[0].plantype;
      usercredit = clientinvoiceforpayment.data[0].userlimit;
    }

    if (
      clientinvoiceforpayment.data &&
      clientinvoiceforpayment.data.length > 0 &&
      clientinvoiceforpayment.data[0].clients_by_clientid.address !== null &&
      clientinvoiceforpayment.data[0].clients_by_clientid.address !== ""
    ) {
      location = clientinvoiceforpayment.data[0].clients_by_clientid.address;
    }

    if (
      clientinvoiceforpayment.data &&
      clientinvoiceforpayment.data.length > 0 &&
      clientinvoiceforpayment.data[0].clients_by_clientid.state !== null &&
      clientinvoiceforpayment.data[0].clients_by_clientid.state !== ""
    ) {
      location = location + "-";
      location =
        location + clientinvoiceforpayment.data[0].clients_by_clientid.state;
    }
    if (
      clientinvoiceforpayment.data &&
      clientinvoiceforpayment.data.length > 0 &&
      clientinvoiceforpayment.data[0].clients_by_clientid.city !== null &&
      clientinvoiceforpayment.data[0].clients_by_clientid.city !== ""
    ) {
      location = location + "-";
      location =
        location + clientinvoiceforpayment.data[0].clients_by_clientid.city;
    }
    if (
      clientinvoiceforpayment.data &&
      clientinvoiceforpayment.data.length > 0 &&
      clientinvoiceforpayment.data[0].clients_by_clientid.zipcode !== null &&
      clientinvoiceforpayment.data[0].clients_by_clientid.zipcode !== ""
    ) {
      location = location + "-";
      location =
        location + clientinvoiceforpayment.data[0].clients_by_clientid.zipcode;
    }

    let content1 = contentData;
    // if (contentData != "") {
    //   let detectURLs = this.fetchURLs(contentData);

    //   if (detectURLs !== null && detectURLs.length > 0) {
    //     _.forEach(detectURLs, (v, i) => {
    //       let a_tag = `<a href=${v} target="_blank">${v}</a>`;
    //       content1 = content1.replace(v, a_tag);
    //     });
    //   }
    // }

    return (
      <>
        <div className="h-100">
          <div className="dashboard-menu pull-left menu-animation">
            <ul className="static-icon">{this.renderLogoMenuIcon()}</ul>
          </div>
          <div className="dashboard-navbar pull-top nav-animation">
            <div className="warp-header-icon">
              <div className="nav-bar-subtitle content-fadein-animation pull-left">
                <div className="nav-bar-subtitle-title">
                  {LocaleStrings.billing_payment_header}
                </div>
                <div className="nav-bar-subtitle-desc">
                  {LocaleStrings.billing_payment_desc}
                </div>
              </div>
              {clientinvoiceforpayment &&
              clientinvoiceforpayment.data &&
              clientinvoiceforpayment.data.length > 0 ? (
                <>
                  {clientinvoiceforpayment.data[0].status == "unpaid" ? (
                    <div className="pull-right mt-3">
                      <Button
                        className="btn-custom-blue schedule-add-button"
                        onClick={() => this.openpayModal()}
                        style={{ marginLeft: "15px" }}>
                        {LocaleStrings.billing_payment_button_payment}
                      </Button>
                    </div>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}

              {/* <div className="pull-right main-header-right-section">
                <div className="d-flex justify-content-end"></div>
              </div> */}
            </div>
          </div>
          {this.state.loading ? (
            <div className="loader-container">
              {this.renderLoader()}
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : (
            <>
              <div
                className="dashboard-content content-fadein-animation "
                style={{
                  float: "left",
                  height: `100vh`,
                }}>
                {clientinvoiceforpayment &&
                clientinvoiceforpayment.data &&
                clientinvoiceforpayment.data.length > 0 ? (
                  <>
                    {clientinvoiceforpayment.data[0].status == "unpaid" ? (
                      <div
                        className="panel-body scrollable-content"
                        style={{
                          height: deviceSize.height - screenHeightLeftFromTop,
                        }}>
                        <div className="">
                          <div className="d-flex">
                            <div className="mt-4">
                              <div className="custom-text1-primary-medium2">
                                {_.startCase(
                                  clientinvoiceforpayment.data[0].type
                                )}
                              </div>
                              <div className="custom-text1-gray">
                                {" "}
                                {_.startCase(
                                  clientinvoiceforpayment.data[0].type
                                )}
                                : {clientinvoiceforpayment.data[0].id}
                              </div>
                              <div className="custom-text1-gray">
                                {
                                  LocaleStrings.accountsetting_billing_details_issued_on
                                }{" "}
                                {tabledate}
                              </div>
                            </div>
                            <div className="ms-auto d-flex">
                              <img
                                className="eventify-logo"
                                src="../../style/images/eventify-logo.png"
                              />
                              <div className="align-self-center custom-text1-primary-medium">
                                {LocaleStrings.by}
                              </div>
                              <img
                                className="teks-logo-"
                                src="../../style/images/Teks-logo-color.png"
                              />
                            </div>
                          </div>

                          <div className="d-flex detail-subheader">
                            <div className="detail-subheader-box">
                              <div className="custom-text1-primary-medium">
                                {
                                  LocaleStrings.accountsetting_billingdetails_subheader_box1_plantype
                                }
                              </div>
                              <div className="custom-text1-gray">
                                {_.startCase(plantype)}
                              </div>
                              <div className="custom-text1-primary-medium mt-2">
                                {
                                  LocaleStrings.accountsetting_billingdetails_subheader_total_user_limit
                                }
                              </div>
                              <div className="custom-text1-gray">
                                {usercredit}
                              </div>
                              {validupto != "" ? (
                                <>
                                  <div className="custom-text1-primary-medium mt-2">
                                    {" "}
                                    {
                                      LocaleStrings.accountsetting_billing_details_validitytill
                                    }
                                  </div>
                                  <div className="custom-text1-gray">
                                    {validupto}
                                  </div>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="detail-subheader-box">
                              <div className="custom-text1-primary-medium">
                                {
                                  LocaleStrings.accountsetting_billingdetails_billed_to
                                }
                              </div>
                              <div className="custom-text1-gray">
                                {" "}
                                {clientinvoiceforpayment.data[0].clientname}
                              </div>
                              <div className="custom-text1-gray">
                                {" "}
                                {clientinvoiceforpayment.data[0].clientemail}
                              </div>
                              <div className="custom-text1-gray">
                                {" "}
                                {location}
                              </div>
                              {clientinvoiceforpayment.data[0]
                                .client_companyname &&
                              clientinvoiceforpayment.data[0]
                                .client_companyname != null &&
                              clientinvoiceforpayment.data[0]
                                .client_companyname != "" ? (
                                <div className="custom-text1-gray">
                                  {
                                    LocaleStrings.accountsetting_billingdetails_subheader_box1_company
                                  }
                                  {
                                    clientinvoiceforpayment.data[0]
                                      .client_companyname
                                  }
                                </div>
                              ) : (
                                ""
                              )}
                              {clientinvoiceforpayment.data[0].vat_number &&
                              clientinvoiceforpayment.data[0].vat_number !=
                                "" &&
                              clientinvoiceforpayment.data[0].vat_number !=
                                null ? (
                                <div className="custom-text1-gray">
                                  {
                                    LocaleStrings.accountsetting_billingdetails_subheader_box1_vatnumber
                                  }
                                  {clientinvoiceforpayment.data[0].vat_number}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="p-20">
                              {/* <div className="custom-text1-primary-medium">
                                {
                                  LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_preparedby
                                }
                              </div> 
                              <div className="custom-text1-gray">
                                {
                                  LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_silasname
                                }
                              </div>*/}
                              <div className="custom-text1-gray">
                                {
                                  LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_teksaddress1
                                }
                              </div>
                              <div className="custom-text1-gray">
                                {
                                  LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_teksaddress2
                                }
                              </div>
                              <div className="custom-text1-gray">
                                {
                                  LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_teksaddress3
                                }
                              </div>
                              {/* <div className="custom-text1-gray">
                                {
                                  LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_silasemail
                                }
                              </div> */}
                            </div>
                          </div>
                          {/* <div className="text-center">
                            <div>
                              <img
                                className=""
                                src="../../style/images/Teks-logo-color.png"
                              />
                            </div>
                            <div className="" >
                              <div className="custom-text1-primary-medium">{LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_teksaddress1}</div>
                              <div className="custom-text1-primary-medium">{LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_teksaddress2}</div>
                              <div className="custom-text1-primary-medium">{LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_teksaddress3}</div>

                            </div>
                          </div> */}
                          {/* <br />
                          <div className="text-center custom-text1-primary-medium">
                            {_.startCase(clientinvoiceforpayment.data[0].type)}
                          </div> */}
                          {/* <div className="custom-text1-primary-medium mt-1 text-center">
                            Plan Type:{" "}
                            {plantype == "trial"
                              ? "Trial"
                              : plantype == "myhub"
                              ? "My Hub"
                              : plantype == "whitelabel"
                              ? "White Label"
                              : plantype == "multiplewhitelabel"
                              ? "Multiple White Label"
                              : plantype == "myhubgroup"
                              ? "My Hub Group"
                              : "No Plan Added"}
                          </div> */}
                          {/* <div className="d-flex">
                            <div>
                              <div className="custom-text1-primary-medium">
                                {
                                  LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_to
                                }
                              </div>
                              <div className="custom-text1-primary-medium">
                                {clientinvoiceforpayment.data[0].clientname}
                              </div>
                              <div className="custom-text1-primary-medium">
                                {clientinvoiceforpayment.data[0].clientemail}
                              </div>
                              <div className="custom-text1-primary-medium">
                                {clientinvoiceforpayment.data[0].client_address}
                              </div>
                              {clientinvoiceforpayment.data[0]
                                ?.clients_by_clientid?.vat_number !== "" &&
                              clientinvoiceforpayment.data[0]
                                ?.clients_by_clientid?.vat_number !== null ? (
                                <div className="custom-text1-primary-medium">
                                  {
                                    LocaleStrings.accountsetting_billing_details_view_vat
                                  }{" "}
                                  {
                                    clientinvoiceforpayment.data[0]
                                      .clients_by_clientid.vat_number
                                  }
                                </div>
                              ) : (
                                ""
                              )}
                              <div className="custom-text1-primary-medium">
                                {
                                  LocaleStrings.accountsetting_billing_details_validitytill
                                }{" "}
                                {validupto}
                              </div>
                              <div className="custom-text1-primary-medium">
                                {
                                  LocaleStrings.accountsetting_billing_details_usercredit
                                }{" "}
                                {usercredit}
                              </div>
                            </div>
                            <div
                              className="text-end "
                              style={{ marginLeft: "auto" }}>
                              <div className="custom-text1-primary-medium">
                                {_.startCase(
                                  clientinvoiceforpayment.data[0].type
                                )}{" "}
                                #{clientinvoiceforpayment.data[0].id}
                              </div>
                              <div className="custom-text1-primary-medium">
                                {
                                  LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_preparedon
                                }{" "}
                                {tabledate}
                              </div>
                              <div className="custom-text1-primary-medium">
                                {
                                  LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_preparedby
                                }{" "}
                                {
                                  LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_silasname
                                }
                              </div>
                              <div className="custom-text1-primary-medium">
                                {
                                  LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_silasemail
                                }
                              </div>
                            </div>
                          </div> */}
                          {clientinvoiceforpayment.data &&
                          clientinvoiceforpayment.data.length > 0 &&
                          clientinvoiceforpayment.data[0]
                            .clientinvoiceitems_by_invoiceidfk.length > 0 ? (
                            <>
                              <div className="mt-5">
                                <table className="table">
                                  <thead>
                                    <tr>
                                      <th align="center">
                                        {
                                          LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_th1
                                        }
                                      </th>
                                      <th align="center">
                                        {
                                          LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_th2
                                        }
                                      </th>
                                      <th align="center">
                                        {
                                          LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_th5
                                        }
                                      </th>
                                      <th align="center">
                                        {
                                          LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_th4
                                        }
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody className="tbody-background">
                                    {this.renderList()}
                                  </tbody>
                                </table>
                              </div>
                              <div
                                className="custom-text1-primary-medium text-end"
                                style={{ marginLeft: "auto" }}>
                                <div
                                  className=""
                                  style={{ marginRight: "11%" }}>
                                  {
                                    LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_grandtotal
                                  }{" "}
                                  $
                                  {clientinvoiceforpayment.data[0].total_amount.toFixed(
                                    2
                                  )}
                                </div>
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                          <div className="row">
                            <div className="col-md-8">
                              <div className="mt-5 custom-text1-primary-medium">
                                {
                                  LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_thankyou
                                }
                              </div>
                              <div className="mt-2 custom-text1-primary-medium">
                                {
                                  LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_terms
                                }
                              </div>
                              <div className="mt-2 custom-text1-primary-medium">
                                {renderHTML(content1)}
                              </div>
                            </div>
                          </div>
                          {/* <Button
                         className="btn-custom-blue schedule-add-button"
                         onClick={() => this.openpayModal()}
                         style={{ marginLeft: "15px" }}
                       >
                         {LocaleStrings.billing_payment_button_payment}
                       </Button> */}
                        </div>
                        <div className="viewbilling_lastsection">
                          <div className="mt-5 custom-text1-primary-medium">
                            {
                              LocaleStrings.accountsetting_billing_details_table_viewmodal_tq
                            }
                          </div>
                          <div className="custom-text1-gray mt-2">
                            {
                              LocaleStrings.accountsetting_billing_details_table_viewmodal_tq1
                            }
                          </div>
                        </div>
                        <div className="d-flex mt-2">
                          <div
                            className="custom-text1-gray"
                            style={{ width: "50%" }}>
                            {
                              LocaleStrings.accountsetting_billing_details_table_viewmodal_eventifysite
                            }
                          </div>
                          <div className="ms-auto">
                            <div className="d-flex">
                              {/* <div className="custom-text1-gray">
                                {
                                  LocaleStrings.accountsetting_billing_details_table_viewmodal_eventifyphoneno
                                }
                              </div> */}
                              <div className="custom-text1-gray ml-2">
                                {
                                  LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_eventifyemail
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <>
                        {clientinvoiceforpayment.data[0].status ==
                        "cancelled" ? (
                          <div className="no-content-container">
                            <div className="no-content-message">
                              {
                                LocaleStrings.billing_payment_quote_already_cancelled
                              }
                            </div>
                          </div>
                        ) : clientinvoiceforpayment.data[0].status == "paid" ? (
                          <div className="no-content-container">
                            <div className="no-content-message">
                              {LocaleStrings.billing_payment_quote_already_paid}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                  </>
                ) : (
                  <div className="no-content-container">
                    <div className="no-content-message">
                      {LocaleStrings.billing_payment_noinvoicefound}
                    </div>
                  </div>
                )}
              </div>
              {this.state.payModal ? (
                <PaymentinvoiceModal
                  isOpen={this.state.payModal}
                  onClose={this.closepayModal}
                  data={clientinvoiceforpayment.data[0]}
                  comeFrom="billpayementoutside"
                  history={this.props.history}
                />
              ) : (
                ""
              )}
            </>
          )}
        </div>
      </>
    );
  }
}
function mapStateToProps(state, ownProps) {
  return {
    session: state.session,
    clientinvoiceforpayment: state.clientinvoiceforpayment,
    deviceSize: state.deviceSize,
  };
}
export default connect(mapStateToProps, {
  fetchclientInvoiceinfo,
})(
  reduxForm({
    form: "BillingpaymentlForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(Billingpayment)
);
